import React from 'react'
import './button.scss'

export const Button = (props) => {
	if (props.href) 
		return (<a href={props.href} target="_blank" className={`button ${props.color}`}> {props.title}</a>)

	return (<button onClick={props.onClick} className={`button ${props.color}`}> {props.title}</button>)
}